import RequireModule from 'routes/components/RequireModule';

import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import PRACTICE_BEYOND_BILLING_INCOME_I_QUEUE from './income-i-queue';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const BeyondBilling = withLazyFallback(() => import('components/practice/BeyondBilling'));
const CMS1500 = withLazyFallback(
  () => import('components/practice/BeyondBilling/Claims/CMS1500/CMS1500')
);
const Eob = withLazyFallback(() => import('components/practice/BeyondBilling/ERA&EOB/EOB/Eob'));

const Era = withLazyFallback(() => import('components/practice/BeyondBilling/ERA&EOB/ERA/Era'));

const ViewEra = withLazyFallback(
  () => import('components/practice/BeyondBilling/ERA&EOB/ERA/components/ViewEra/ViewEra')
);
const NewClaims = withLazyFallback(
  () => import('components/practice/BeyondBilling/Claims/NewClaims')
);
const DynamicAR = withLazyFallback(
  () => import('components/practice/BeyondBilling/DynamicAR/DynamicAR')
);
const ElectronicInvoicing = withLazyFallback(
  () => import('components/practice/BeyondBilling/ElectronicInvoicing/ElectronicInvoicing')
);
const InternalInvoices = withLazyFallback(
  () => import('components/practice/BeyondBilling/ElectronicInvoicing/InternalInvoices')
);
const ExternalInvoices = withLazyFallback(
  () => import('components/practice/BeyondBilling/ElectronicInvoicing/ExternalInvoices')
);
const ViewInternalInvoice = withLazyFallback(
  () =>
    import('components/practice/BeyondBilling/ElectronicInvoicing/components/ViewInternalInvoice')
);
const PatientLedger = withLazyFallback(
  () => import('components/practice/BeyondBilling/PatientLedger/PatientLedger')
);
const Payments = withLazyFallback(
  () => import('components/practice/BeyondBilling/Payments/Payments')
);
const BeyondBillingReports = withLazyFallback(
  () => import('components/practice/BeyondBilling/Reports/BeyondBillingReports')
);
const CustomReports = withLazyFallback(
  () => import('components/practice/BeyondBilling/Reports/pages/CustomReports/CustomReports')
);
const FavoriteReports = withLazyFallback(
  () => import('components/practice/BeyondBilling/Reports/pages/FavoriteReports/FavoriteReports')
);
const StandardReports = withLazyFallback(
  () => import('components/practice/BeyondBilling/Reports/pages/StandardReports/StandardReports')
);
const Superbills = withLazyFallback(
  () => import('components/practice/BeyondBilling/Superbill/Superbills')
);
const BeyondBillingOverview = withLazyFallback(
  () => import('components/practice/BeyondBilling/Overview/Overview')
);

const Plans = withLazyFallback(() => import('components/practice/BeyondBilling/Plans/Plans'));
const AutoRecurring = withLazyFallback(
  () => import('components/practice/BeyondBilling/Plans/components/AutoRecurring/AutoRecurring')
);
const Installments = withLazyFallback(
  () => import('components/practice/BeyondBilling/Plans/components/Installments/Installments')
);

const PRACTICE_BEYOND_BILLING = [
  {
    path: 'beyond-billing',
    element: <BeyondBilling />,
    handle: { title: 'Beyond Billing' },
    children: [
      { path: '', element: <BeyondBillingOverview />, handle: { title: 'Overview' } },
      PRACTICE_BEYOND_BILLING_INCOME_I_QUEUE,
      {
        path: 'payments',
        element: <Payments />,
        handle: { title: 'Payments' },
        children: [{ path: 'era/:id', element: <ViewEra /> }]
      },
      {
        path: 'plans',
        element: (
          <RequireModule module="medipay.payment_suite.recurring_charges">
            <Plans />
          </RequireModule>
        ),
        handle: { title: 'Plans' },
        children: [
          {
            path: 'auto-recurring',
            element: <AutoRecurring />,
            handle: { title: 'Auto-recurring payments' }
          },
          { path: 'installments', element: <Installments />, handle: { title: 'Installments' } }
        ]
      },
      {
        path: 'patient-ledger',
        element: <PatientLedger name="patient_ledger" />,
        handle: { title: 'Patient ledger' }
      },
      {
        path: 'dynamic-ar',
        element: <DynamicAR />,
        handle: { title: 'Dynamic AR' },
        children: [{ path: ':type', element: <DynamicAR /> }]
      },
      {
        path: 'era',
        element: (
          <RequireModule module="billing.era_eob_posting">
            <Era />
          </RequireModule>
        ),
        handle: { title: 'ERA' },
        children: [{ path: ':id', element: <ViewEra /> }]
      },
      {
        path: 'eob',
        element: (
          <RequireModule module="billing.era_eob_posting">
            <Eob />
          </RequireModule>
        ),
        handle: { title: 'EOB' },
        children: [{ path: ':id', element: <ViewEra /> }]
      },
      {
        path: 'claims',
        element: (
          <RequireModule module="billing.claims">
            <NewClaims />
          </RequireModule>
        ),
        handle: { title: 'Claims' },
        children: [
          { path: ':id', element: <CMS1500 /> },
          { path: '*', element: <NotFound /> }
        ]
      },
      {
        path: 'superbills',
        element: (
          <RequireModule module="billing.superbills">
            <Superbills />
          </RequireModule>
        ),
        handle: { title: 'Superbills' },
        children: [
          { path: 'claim/:claimId', element: <CMS1500 /> },
          { path: '*', element: <NotFound /> }
        ]
      },
      {
        path: 'electronic-invoicing',
        element: <ElectronicInvoicing />,
        handle: { title: 'Electronic invoices' },
        children: [
          {
            path: '',
            element: <InternalInvoices />,
            children: [{ path: ':invoiceId', element: <ViewInternalInvoice fromRoute /> }]
          },
          {
            path: 'external',
            element: (
              <RequireModule module="medipay.payment_suite.electronic_invoicing">
                <ExternalInvoices />
              </RequireModule>
            ),
            handle: { title: 'External' }
          },
          { path: '*', element: <NotFound /> }
        ]
      },
      {
        path: 'reports',
        element: (
          <RequireModule module={['core.reporting_center', 'medipay.payment_suite']}>
            <BeyondBillingReports />
          </RequireModule>
        ),
        children: [
          {
            path: 'standard',
            element: <StandardReports />,
            handle: { title: 'Standard reports' }
          },
          {
            path: 'favorite',
            element: <FavoriteReports />,
            handle: { title: 'Favorite reports' }
          },
          { path: 'custom', element: <CustomReports />, handle: { title: 'Custom reports' } }
        ]
      },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default PRACTICE_BEYOND_BILLING;
